import {
    ProductReviewFormContainer as SourceProductReviewFormContainer,
    mapDispatchToProps
} from 'SourceComponent/ProductReviewForm/ProductReviewForm.container';
import { connect } from 'react-redux';

export const mapStateToProps = state => ({
    customer: state.MyAccountReducer.customer,
    isSignedIn: state.MyAccountReducer.isSignedIn,
    reviewRatings: state.ConfigReducer.reviewRatings,
    customerAdditionalAttributes: state.ConfigReducer.customerAdditionalAttributes,
    householdSkuList: state.ConfigReducer.householdSkuList // New prop from config
});

export class ProductReviewFormContainer extends SourceProductReviewFormContainer {
    containerFunctions = ({
        onReviewSubmitAttempt: this._onReviewSubmitAttempt.bind(this),
        onReviewSubmitSuccess: this._onReviewSubmitSuccess.bind(this),
        onStarRatingClick: this._onStarRatingClick.bind(this),
        handleNicknameChange: this._handleFieldChange.bind(this, 'nickname'),
        handleEmailChange: this._handleFieldChange.bind(this, 'email'),
        handleDetailChange: this._handleFieldChange.bind(this, 'detail'),
        onReviewError: this._onReviewError.bind(this),
        handleAgreementChange: this._handleFieldChange.bind(this, "is_agreement"),
        handleSubscribeChange: this._handleFieldChange.bind(this, "is_subscribe"),
    });

    getLabelFromAttribute(key, value) {
        if (!value || !this.props.customerAdditionalAttributes) {
            return null;
        }
        const attributeList = this.props.customerAdditionalAttributes;

        return attributeList[key].attribute_options[parseInt(value, 10)-1].label;
    }

    _onReviewSubmitAttempt(_, invalidFields) { // translate string
        const { showNotification, reviewRatings } = this.props;
        const { ratingData } = this.state;

        const reviewsAreNotValid = invalidFields
            || !reviewRatings.every(({ rating_id }) => ratingData[rating_id]);

        if (reviewsAreNotValid) {
            showNotification('info', __('Incorrect data! Please check review fields.'));
        }

        this.setState({ isLoading: !reviewsAreNotValid });
    }

    _onReviewSubmitSuccess(fields) {
        const {
            product,
            addReview,
            hideActiveOverlay,
            goToPreviousHeaderState,
            customer
        } = this.props;

        const {
            ratingData: rating_data,
            isLoading
        } = this.state;

        const {
            nickname,
            email,
            detail = '',
            sex = undefined,
            age = undefined,
            tip_par = undefined,
            tip_ten = undefined,
            is_agreement,
            is_subscribed
        } = fields;

        const { sku: product_sku } = product;

        if (Object.keys(rating_data).length && isLoading ) {
            addReview({
                nickname,
                email: customer.email || email,
                title: '',
                detail,
                product_sku,
                rating_data,
                sex: sex || null,
                age: age || null,
                tip_ten: tip_ten || null,
                tip_par: tip_par || null,
                is_agreement,
                is_subscribed
            }).then((success) => {
                if (success) {
                    this.setState({
                        ratingData: {},
                        reviewData: {},
                        isLoading: false
                    });

                    goToPreviousHeaderState();
                    hideActiveOverlay();

                    return;
                }

                this.setState({ isLoading: false });
            });
        }
    }
}


export default connect(mapStateToProps, mapDispatchToProps)(ProductReviewFormContainer);
